import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated, loading, staff } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const perms = Array.isArray(staff?.permissions) ? staff.permissions : [];
  const isAdmin = perms.includes('admin:full') || String(staff?.role || '').toLowerCase() === 'admin';
  const canAccessTempleDashboard = isAdmin || perms.includes('reports:view') || perms.includes('temple:access') || perms.includes('analytics:view');
  const path = location?.pathname || '';

  // Temple dashboard is the default authenticated landing for dashboard/report users.
  if (!canAccessTempleDashboard && (path === '/dashboard' || path.startsWith('/dashboard/'))) {
    return <Navigate to="/welcome" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
